export enum ReferenceSubmissionTypes {
	Education = 1,
	Professional = 2,
	Character = 3,
	Factual = 4,
	Academic = 5,
	Volunteer = 6,
}
